import React, { useState } from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import PropTypes from 'prop-types';

import { formatAsCurrency } from 'utils/currency/formatAsCurrency';

import AccountCalculator from './components/AccountCalculator/AccountCalculator';
import { StyledTypography } from './styles/Typography';

function SectionCalculator({ index }) {
  const [balance, setBalance] = useState(undefined);
  return (
    <Box
      tag="section"
      display="grid"
      paddingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
      paddingHorizontal={{ xs: '6x', md: 40, lg: 56 }}
      gridTemplateColumns={{ md: 'repeat(6,1fr)', lg: 'repeat(12,1fr)' }}
      gridColumnGap={{ md: '8x' }}
      gridRowGap={{ xs: '12x', md: '16x', lg: '20x' }}
    >
      <Box gridColumn={{ md: '1 / span 6', lg: '2 / span 6' }}>
        <Typography
          variant="title"
          marginBottom="6x"
          intlKey={`cms.accountPage.cardsArea[${index}].title`}
        />
        <Typography variant="subtitle" intlKey={`cms.accountPage.cardsArea[${index}].description`} />
      </Box>
      <Box gridColumn={{ md: '1 / span 4', lg: '2 / span 5', xl: '2 / span 4' }}>
        <AccountCalculator onBalanceChange={setBalance} />
      </Box>
      <Box gridColumn={{ md: '1 / span 5', lg: '7 / span 5' }} display="flex" flexDirection="column" justifyContent="space-between">
        <Box marginBottom="6x">
          <Typography
            variant="subtitle"
            marginBottom="6x"
            intlKey="ACCOUNT.CALCULATOR.RESULTS.LABEL"
            intlValues={{ period: balance?.periodInYears }}
          />
          <StyledTypography marginBottom="4x">
            {formatAsCurrency(balance?.liquidBalance)}
          </StyledTypography>
          <Typography
            variant="paragraph2"
            marginBottom="1x"
            intlKey="ACCOUNT.CALCULATOR.RESULTS.RAW_VALUE"
            intlValues={{ value: formatAsCurrency(balance?.rawBalance) }}
          />
          <Typography
            variant="paragraph2"
            intlKey="ACCOUNT.CALCULATOR.RESULTS.LIQUID_VALUE"
            intlValues={{ value: formatAsCurrency(balance?.accumulator) }}
          />
        </Box>
        <Typography variant="paragraph1" intlKey={`cms.accountPage.cardsArea[${index}].observation`} />
      </Box>
    </Box>
  );
}

SectionCalculator.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionCalculator);
